import styled from '@emotion/styled';

import { BannerTableContainer, HeaderContainer, Header } from '@/pages/PromotionalBanners/PromotionalBanners.style';

export const Container = styled(BannerTableContainer)`
    margin: ${({ theme }) => theme.savory.spacing[3]};
    background-color: #fafafa;
    border: 1px solid #ededed;
`;

export { HeaderContainer, Header };
